<template>
  <section v-on:click="sectionClicked" class="pageContents">
    <div class="cnt" v-if="displayAs === 'tab'">
      <div class="loadingCategory" v-if="loadingCategory"></div>
    </div>
    <template v-if="displayAs === 'tab'">
      <div class="tabDdCnt" v-if="!loadingCategory" :class="{open: ddOpen}">
        <div class="cnt">
          <div class="tabDd" v-on:click.stop="ddOpen = !ddOpen">
            {{newsCategory[categorySelected].name}}</div>
          <div class="thumbSelector">
            <div class="thumbItem list" :class="{active: viewType === 'list'}"
              v-on:click="selectViewType('list')">
              <img src="../assets/list.png">
            </div>
            <div class="thumbItem grid" :class="{active: viewType === 'grid'}"
              v-on:click="selectViewType('grid')">
              <img src="../assets/grid.png">
            </div>
          </div>
        </div>
        <div class="tabCnt" v-on:click.stop="doNothing">
          <div class="cnt">
            <div class="tabItem" :class="{active: categorySelected === i}"
              v-for="(item, i) in newsCategory" :key="item.id"
              v-on:click.stop="selectTab(i, item); ddOpen = false">
              {{item.name}}
            </div>
          </div>
        </div>
      </div>
    </template>
    <div class="tabDdCnt tabFixed" v-if="!loadingCategory && tabFixed"
      :class="{open: ddOpen}">
      <div class="cnt">
        <div class="tabDd" v-on:click.stop="ddOpen = !ddOpen">
          {{newsCategory[categorySelected].name}}</div>
        <div class="thumbSelector">
          <div class="thumbItem list" :class="{active: viewType === 'list'}"
            v-on:click="selectViewType('list')">
            <img src="../assets/list.png">
          </div>
          <div class="thumbItem grid" :class="{active: viewType === 'grid'}"
            v-on:click="selectViewType('grid')">
            <img src="../assets/grid.png">
          </div>
        </div>
      </div>
      <div class="tabCnt" v-on:click.stop="doNothing">
        <div class="cnt">
          <div class="tabItem" :class="{active: categorySelected === i}"
            v-for="(item, i) in newsCategory" :key="item.id"
            v-on:click.stop="selectTab(i, item); ddOpen = false">
            {{item.name}}
          </div>
        </div>
      </div>
    </div>
    <div class="cnt">
      <div class="loadingFull loadingNews" v-if="loading"></div>
      <div class="noNews" v-else-if="displayAs === 'tab' && results.length < 1">
        <template v-if="lang === 'id'">
          Tidak ada artikel pada kategori ini
        </template>
        <template v-if="lang === 'en'">
          There is no article for this category
        </template>
      </div>
      <div class="noNews noNewsSearch" v-else-if="page.uri === '/search' && results.length < 1">
        <template v-if="lang === 'id'">
          Tidak ditemukan hasil pencarian untuk kata kunci <b><i>{{q}}</i></b>.
          Coba ganti kata kunci pencarian kamu.
        </template>
        <template v-if="lang === 'en'">
          No search results were found for the keyword <b><i>{{q}}</i></b>.
          Try changing your search keywords.
        </template>
      </div>
      <div class="viewType" v-if="!search">
        <div class="viewTypeItem grid" :class="{active: viewType === 'grid'}"
          v-on:click="selectViewType('grid')"></div>
        <div class="viewTypeItem list" :class="{active: viewType === 'list'}"
          v-on:click="selectViewType('list')"></div>
      </div>
      <div class="itemCnt" :class="[viewType, results[0].type]" v-if="results.length > 0">
        <div class="item" v-for="(item, i) in results" :key="i"
          :class="[item.type, {protected: item.isProtected}]">
          <div class="itemIn">
            <template v-if="item.type === 'link'">
              <a :href="item.linkUrl" target="_blank">
                <div class="itemImg" v-if="item.thumb[lang]"
                  :style="{'background-image': `url(${item.thumb[lang]})`}"
                  :class="item.coverStyle">
                  <div class="protectedContent" v-if="item.isProtected">
                    <img src="../assets/padlock-white.png">
                    <h4 v-if="lang === 'en'">Locked Content</h4>
                    <h4 v-if="lang === 'id'">Konten Terkunci</h4>
                  </div>
                </div>
                <div class="itemImg noImg" v-else>
                  <div class="protectedContent" v-if="item.isProtected">
                    <img src="../assets/padlock-white.png">
                    <h4 v-if="lang === 'en'">Locked Content</h4>
                    <h4 v-if="lang === 'id'">Konten Terkunci</h4>
                  </div>
                </div>
              </a>
              <div class="itemInfo">
                <div class="itemInfoIn">
                  <div class="tags" v-if="item.tags.length > 0">
                    <div class="tagItem" v-for="(tag, i) in item.tags" :key="`tag${i}`">
                      {{tag.trim()}}
                    </div>
                  </div>
                  <a :href="item.linkUrl" target="_blank">
                    <h4>{{item.title[lang]}}</h4>
                    <template v-if="item.type === 'profile' && !item.isProtected">
                      <p v-if="item.position && item.position[lang]">{{item.position[lang]}}</p>
                    </template>
                    <div class="metadataCnt">
                      <div class="metadata publishDate" v-if="item.publishDate
                        && item.displayPublishDate">
                        {{item.publishDate | moment(item.dateFormat)}}
                      </div>
                      <a :href="`${$config.appPath}${langCode}/author/${item.author.code}`"
                        class="metadata author" v-if="item.author && item.displayAuthor">
                        {{item.author.name}}
                      </a>
                      <div class="metadata views" v-if="item.displayViews">
                        <template v-if="item.viewCount > 1">
                          <template v-if="item.viewCount >= 1000000000">
                            {{Math.floor(item.viewCount/1000000000).toLocaleString('id')}}b
                          </template>
                          <template v-else-if="item.viewCount >= 1000000">
                            {{Math.floor(item.viewCount/1000000).toLocaleString('id')}}m
                          </template>
                          <template v-if="item.viewCount >= 1000">
                            {{Math.floor(item.viewCount/1000).toLocaleString('id')}}k
                          </template>
                          <template v-else-if="item.viewCount">
                            {{item.viewCount.toLocaleString('id')}}
                          </template>
                          views
                        </template>
                        <template v-else>{{item.viewCount || 0}} view</template>
                      </div>
                      <div class="metadata directory" v-if="item.parent
                        && page.uri === '/search'">
                        {{item.parent.name[lang]}}
                      </div>
                      <div class="metadata location" v-if="item.location">
                        {{item.location[lang]}}
                      </div>
                      <div class="metadata organizer" v-if="item.organizer">
                        {{item.organizer[lang]}}
                      </div>
                      <div class="metadata speaker" v-if="item.speaker">
                        {{item.speaker[lang]}}
                      </div>
                    </div>
                    <div class="protectedContent" v-if="item.isProtected">
                      <img src="../assets/padlock.png">
                      <h4 v-if="lang === 'en'">Locked Content</h4>
                      <h4 v-if="lang === 'id'">Konten Terkunci</h4>
                    </div>
                    <template v-else-if="item.type !== 'profile'">
                      <p v-if="item.additionalInfo[lang]">{{item.additionalInfo[lang]}}</p>
                      <p v-if="item.description[lang]">{{item.description[lang]}}...</p>
                    </template>
                  </a>
                </div>
                <a :href="item.linkUrl" target="_blank"
                  class="btn secondary readMore">
                  <span v-if="item.type === 'profile'">
                    <template v-if="lang === 'id'">Selengkapnya</template>
                    <template v-if="lang === 'en'">Read more</template>
                  </span></a>
              </div>
            </template>
            <template v-else>
              <a :href="`/${langCode}${page.uri}/v/${item.code}`">
                <div class="itemImg eventDate" v-if="item.type === 'event'">
                  <div class="protectedContent" v-if="item.isProtected">
                    <img src="../assets/padlock-white.png">
                    <h4 v-if="lang === 'en'">Locked Content</h4>
                    <h4 v-if="lang === 'id'">Konten Terkunci</h4>
                  </div>
                  <div class="theDate" v-else>
                    <div class="edDate">
                      {{item.eventDate | moment('DD')}}
                    </div>
                    <div class="edMonth">
                      {{item.eventDate | moment('MMM YYYY')}}
                    </div>
                  </div>
                </div>
                <div class="itemImg" v-else-if="item.thumb[lang]"
                  :style="{'background-image': `url(${item.thumb[lang]})`}"
                  :class="item.coverStyle">
                  <div class="protectedContent" v-if="item.isProtected">
                    <img src="../assets/padlock-white.png">
                    <h4 v-if="lang === 'en'">Locked Content</h4>
                    <h4 v-if="lang === 'id'">Konten Terkunci</h4>
                  </div>
                </div>
                <div class="itemImg noImg" :class="item.type" v-else>
                  <div class="protectedContent" v-if="item.isProtected">
                    <img src="../assets/padlock-white.png">
                    <h4 v-if="lang === 'en'">Locked Content</h4>
                    <h4 v-if="lang === 'id'">Konten Terkunci</h4>
                  </div>
                </div>
              </a>
              <div class="itemInfo">
                <div class="itemInfoIn">
                  <div class="tags" v-if="item.tags.length > 0">
                    <div class="tagItem" v-for="(tag, i) in item.tags" :key="`tag${i}`">
                      {{tag.trim()}}
                    </div>
                  </div>
                  <a :href="`/${langCode}${page.uri}/v/${item.code}`">
                    <h4>{{item.title[lang]}}</h4>
                    <template v-if="item.type === 'profile' && !item.isProtected">
                      <p v-if="item.position && item.position[lang]">{{item.position[lang]}}</p>
                    </template>
                    <div class="metadataCnt">
                      <div class="metadata publishDate" v-if="item.publishDate
                        && item.displayPublishDate">
                        {{item.publishDate | moment(item.dateFormat)}}
                      </div>
                      <a :href="`${$config.appPath}${langCode}/author/${item.author.code}`"
                        class="metadata author" v-if="item.author && item.displayAuthor">
                        {{item.author.name}}
                      </a>
                      <div class="metadata views" v-if="item.displayViews">
                        <template v-if="item.viewCount > 1">
                          <template v-if="item.viewCount >= 1000000000">
                            {{Math.floor(item.viewCount/1000000000).toLocaleString('id')}}b
                          </template>
                          <template v-else-if="item.viewCount >= 1000000">
                            {{Math.floor(item.viewCount/1000000).toLocaleString('id')}}m
                          </template>
                          <template v-if="item.viewCount >= 1000">
                            {{Math.floor(item.viewCount/1000).toLocaleString('id')}}k
                          </template>
                          <template v-else-if="item.viewCount">
                            {{item.viewCount.toLocaleString('id')}}
                          </template>
                          views
                        </template>
                        <template v-else>{{item.viewCount || 0}} view</template>
                      </div>
                      <div class="metadata directory" v-if="item.parent
                        && page.uri === '/search'">
                        {{item.parent.name[lang]}}
                      </div>
                      <div class="metadata location" v-if="item.location">
                        {{item.location[lang]}}
                      </div>
                      <div class="metadata organizer" v-if="item.organizer">
                        {{item.organizer[lang]}}
                      </div>
                      <div class="metadata speaker" v-if="item.speaker">
                        {{item.speaker[lang]}}
                      </div>
                    </div>
                    <div class="protectedContent" v-if="item.isProtected">
                      <img src="../assets/padlock.png">
                      <h4 v-if="lang === 'en'">Locked Content</h4>
                      <h4 v-if="lang === 'id'">Konten Terkunci</h4>
                    </div>
                    <template v-else-if="item.type !== 'profile'">
                      <p v-if="item.additionalInfo[lang]">{{item.additionalInfo[lang]}}</p>
                      <p v-if="item.description[lang]">{{item.description[lang]}}...</p>
                    </template>
                  </a>
                </div>
                <a :href="`/${langCode}${page.uri}/v/${item.code}`" class="btn secondary readMore">
                  <template v-if="item.type === 'profile'">
                    <span v-if="lang === 'id'">Lihat Profil</span>
                    <span v-if="lang === 'en'">View Profile</span>
                  </template>
                  <template v-else>
                    <span v-if="lang === 'id'">Selengkapnya</span>
                    <span v-if="lang === 'en'">Read more</span>
                  </template>
                </a>
                <a :href="item.googleScholerUri[lang]" class="btn scholar" target="_blank"
                  v-if="item.type === 'profile' && item.googleScholerUri
                  && item.googleScholerUri[lang]"></a>
              </div>
            </template>
          </div>
        </div>
      </div>

      <div class="pagination" v-if="!loading && results.length > 0
        && pagination.pages.length > 1"
        :class="{center: viewType === 'list'}">
        <div class="pItem" v-if="pagination.page">
          <a :href="`?q=${q}&page=${pagination.page}`">
            <template v-if="lang === 'id'">Sebelumnya</template>
            <template v-if="lang === 'en'">Previous</template>
          </a>
        </div>
        <div class="pItem" v-for="i in pagination.pages" :key="`p${i}`">
          <span v-if="i === '...'">{{i}}</span>
          <a :href="`?q=${q}&page=${i}`" v-else
            :class="{active: i - 1 === pagination.page}">{{i}}</a>
        </div>
        <div class="pItem" v-if="pagination.page + 1 < pagination.totalPages">
          <a :href="`?q=${q}&page=${pagination.page + 2}`">
            <template v-if="lang === 'id'">Berikutnya</template>
            <template v-if="lang === 'en'">Next</template>
          </a>
        </div>
      </div>

      <div class="itemList" v-if="displayAs === 'list'">
        <div class="itemListItem" v-for="(directory, i) in directories" :key="`dir${i}`">
          <h4 class="directoryName">{{directory.name[lang]}}</h4>
          <div class="itemCnt" :class="viewType">
            <div class="item" v-for="(item, i2) in directory.contents"
              :key="`cn${i}-${i2}`" :class="[item.type, {protected: item.isProtected}]">
              <div class="itemIn">
                <template v-if="item.type === 'link'">
                  <a :href="item.linkUrl" target="_blank">
                    <div class="itemImg" v-if="item.thumb[lang]"
                      :style="{'background-image': `url(${item.thumb[lang]})`}"
                      :class="item.coverStyle">
                      <div class="protectedContent" v-if="item.isProtected">
                        <img src="../assets/padlock-white.png">
                        <h4 v-if="lang === 'en'">Locked Content</h4>
                        <h4 v-if="lang === 'id'">Konten Terkunci</h4>
                      </div>
                    </div>
                    <div class="itemImg noImg" v-else>
                      <div class="protectedContent" v-if="item.isProtected">
                        <img src="../assets/padlock-white.png">
                        <h4 v-if="lang === 'en'">Locked Content</h4>
                        <h4 v-if="lang === 'id'">Konten Terkunci</h4>
                      </div>
                    </div>
                  </a>
                  <div class="itemInfo">
                    <div class="itemInfoIn">
                      <div class="tags" v-if="item.tags.length > 0">
                        <div class="tagItem" v-for="(tag, i) in item.tags[lang]" :key="`tag${i}`">
                          {{tag.trim()}}
                        </div>
                      </div>
                      <a :href="item.linkUrl" target="_blank">
                        <h4>{{item.title[lang]}}</h4>
                        <template v-if="item.type === 'profile' && !item.isProtected">
                          <p v-if="item.additionalInfo[lang]">{{item.additionalInfo[lang]}}</p>
                        </template>
                        <div class="metadataCnt">
                          <div class="metadata publishDate" v-if="item.publishDate
                            && item.displayPublishDate">
                            {{item.publishDate | moment(item.dateFormat)}}
                          </div>
                          <a :href="`${$config.appPath}${langCode}/author/${item.author.code}`"
                            class="metadata author" v-if="item.author && item.displayAuthor">
                            {{item.author.name}}
                          </a>
                          <div class="metadata views" v-if="item.displayViews">
                            <template v-if="item.viewCount > 1">
                              <template v-if="item.viewCount >= 1000000000">
                                {{Math.floor(item.viewCount/1000000000).toLocaleString('id')}}b
                              </template>
                              <template v-else-if="item.viewCount >= 1000000">
                                {{Math.floor(item.viewCount/1000000).toLocaleString('id')}}m
                              </template>
                              <template v-if="item.viewCount >= 1000">
                                {{Math.floor(item.viewCount/1000).toLocaleString('id')}}k
                              </template>
                              <template v-else-if="item.viewCount">
                                {{item.viewCount.toLocaleString('id')}}
                              </template>
                              views
                            </template>
                            <template v-else>{{item.viewCount || 0}} view</template>
                          </div>
                          <div class="metadata directory" v-if="item.parent
                            && page.uri === '/search'">
                            {{item.parent.name[lang]}}
                          </div>
                          <div class="metadata location" v-if="item.location">
                            {{item.location[lang]}}
                          </div>
                          <div class="metadata organizer" v-if="item.organizer">
                            {{item.organizer[lang]}}
                          </div>
                          <div class="metadata speaker" v-if="item.speaker">
                            {{item.speaker[lang]}}
                          </div>
                        </div>
                        <div class="protectedContent" v-if="item.isProtected">
                          <img src="../assets/padlock.png">
                          <h4 v-if="lang === 'en'">Locked Content</h4>
                          <h4 v-if="lang === 'id'">Konten Terkunci</h4>
                        </div>
                        <template v-else-if="item.type !== 'profile'">
                          <p v-if="item.additionalInfo[lang]">{{item.additionalInfo[lang]}}</p>
                          <p v-if="item.description[lang]">{{item.description[lang]}}...</p>
                        </template>
                      </a>
                    </div>
                    <a :href="item.linkUrl" target="_blank"
                      class="btn secondary readMore">
                      <template v-if="item.type === 'profile'">
                        <span v-if="lang === 'id'">Lihat Profil</span>
                        <span v-if="lang === 'en'">View Profile</span>
                      </template>
                      <template v-else>
                        <span v-if="lang === 'id'">Selengkapnya</span>
                        <span v-if="lang === 'en'">Read more</span>
                      </template>
                    </a>
                  </div>
                </template>
                <template v-else>
                  <a :href="`/${langCode}${page.uri}/v/${item.code}`">
                    <div class="itemImg" v-if="item.thumb[lang]"
                      :style="{'background-image': `url(${item.thumb[lang]})`}"
                      :class="item.coverStyle">
                      <div class="protectedContent" v-if="item.isProtected">
                        <img src="../assets/padlock-white.png">
                        <h4 v-if="lang === 'en'">Locked Content</h4>
                        <h4 v-if="lang === 'id'">Konten Terkunci</h4>
                      </div>
                    </div>
                    <div class="itemImg noImg" :class="item.type" v-else>
                      <div class="protectedContent" v-if="item.isProtected">
                        <img src="../assets/padlock-white.png">
                        <h4 v-if="lang === 'en'">Locked Content</h4>
                        <h4 v-if="lang === 'id'">Konten Terkunci</h4>
                      </div>
                    </div>
                  </a>
                  <div class="itemInfo">
                    <div class="itemInfoIn">
                      <div class="tags" v-if="item.tags.length > 0">
                        <div class="tagItem" v-for="(tag, i) in item.tags" :key="`tag${i}`">
                          {{tag.trim()}}
                        </div>
                      </div>
                      <a :href="`/${langCode}${page.uri}/v/${item.code}`">
                        <h4>{{item.title[lang]}}</h4>
                        <template v-if="item.type === 'profile' && !item.isProtected">
                          <p v-if="item.position && item.position[lang]">{{item.position[lang]}}</p>
                        </template>
                        <div class="metadataCnt">
                          <div class="metadata publishDate" v-if="item.publishDate
                            && item.displayPublishDate">
                            {{item.publishDate | moment(item.dateFormat)}}
                          </div>
                          <a :href="`${$config.appPath}${langCode}/author/${item.author.code}`"
                            class="metadata author" v-if="item.author && item.displayAuthor">
                            {{item.author.name}}
                          </a>
                          <div class="metadata views" v-if="item.displayViews">
                            <template v-if="item.viewCount > 1">
                              <template v-if="item.viewCount >= 1000000000">
                                {{Math.floor(item.viewCount/1000000000).toLocaleString('id')}}b
                              </template>
                              <template v-else-if="item.viewCount >= 1000000">
                                {{Math.floor(item.viewCount/1000000).toLocaleString('id')}}m
                              </template>
                              <template v-if="item.viewCount >= 1000">
                                {{Math.floor(item.viewCount/1000).toLocaleString('id')}}k
                              </template>
                              <template v-else-if="item.viewCount">
                                {{item.viewCount.toLocaleString('id')}}
                              </template>
                              views
                            </template>
                            <template v-else>{{item.viewCount || 0}} view</template>
                          </div>
                          <div class="metadata directory" v-if="item.parent
                            && page.uri === '/search'">
                            {{item.parent.name[lang]}}
                          </div>
                          <div class="metadata location" v-if="item.location">
                            {{item.location[lang]}}
                          </div>
                          <div class="metadata organizer" v-if="item.organizer">
                            {{item.organizer[lang]}}
                          </div>
                          <div class="metadata speaker" v-if="item.speaker">
                            {{item.speaker[lang]}}
                          </div>
                        </div>
                        <div class="protectedContent" v-if="item.isProtected">
                          <img src="../assets/padlock.png">
                          <h4 v-if="lang === 'en'">Locked Content</h4>
                          <h4 v-if="lang === 'id'">Konten Terkunci</h4>
                        </div>
                        <template v-else-if="item.type !== 'profile'">
                          <p v-if="item.additionalInfo[lang]">{{item.additionalInfo[lang]}}</p>
                          <p v-if="item.description[lang]">{{item.description[lang]}}...</p>
                        </template>
                      </a>
                    </div>
                    <a :href="`/${langCode}${page.uri}/v/${item.code}`" class="btn secondary readMore">
                      <template v-if="item.type === 'profile'">
                        <span v-if="lang === 'id'">Lihat Profil</span>
                        <span v-if="lang === 'en'">View Profile</span>
                      </template>
                      <template v-else>
                        <span v-if="lang === 'id'">Selengkapnya</span>
                        <span v-if="lang === 'en'">Read more</span>
                      </template>
                    </a>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'home',
  components: {},
  props: ['page', 'search'],
  data() {
    return {
      loading: true,
      scrolled: false,
      newsCategory: [],
      results: [],
      categorySelected: 0,
      loadingCategory: true,
      ddOpen: false,
      viewType: 'grid',
      tabFixed: false,
      pagination: {
        limit: 8,
        page: 0,
        total: 0,
        totalPages: 0,
        pages: [],
      },
      q: '',

      displayAs: 'list',
      directories: [],

      /**
       * Language
       *
       */
      langCode: 'id-id',
      lang: 'id',
    };
  },
  methods: {
    doNothing() {},
    selectViewType(viewType) {
      localStorage.setItem('icel_content_view_type', viewType);
      this.viewType = viewType;
    },
    sectionClicked() {
      if (this.$refs.header) this.$refs.header.headerClicked();
      this.ddOpen = false;
    },
    docScrolled() {
      this.scrolled = (window.pageYOffset >= 30);
      this.tabFixed = window.pageYOffset >= 128;
    },
    selectTab(i, item) {
      this.categorySelected = i;
      window.history.replaceState({}, item.code, `/berita?tab=${item.code}`);
      this.getData();
    },
    getData() {
      this.loading = true;
      let uri = `article/all?lang=${this.lang}`;
      if (this.page.directory) uri += `&directoryId=${this.page.directory.id}&`;
      uri += `&limit=${this.pagination.limit}&page=${this.pagination.page}`;
      if (this.displayAs === 'tab') {
        uri += `&directory=${this.page.directory.id}`;
      }
      if (this.q) uri += `&q=${this.q}`;
      if (this.page.uri === '/author' && this.page.author) {
        uri += `&author=${this.page.author.id}`;
      }
      this.$http.get(this.$config.uri(uri)).then((r) => {
        this.loading = false;
        this.results = (r.data.status === 200) ? r.data.data : [];
        this.pagination.total = r.data.total;
        this.calcPagination();
      });
    },
    calcPagination() {
      this.pagination.totalPages = Math.ceil(this.pagination.total / this.pagination.limit);
      if (this.pagination.totalPages <= 6) {
        for (let i = 1; i <= this.pagination.totalPages; i += 1) {
          this.pagination.pages.push(i);
        }
      } else {
        const iStart = this.pagination.page < 1 ? 0 : this.pagination.page - 1;
        this.pagination.pages = [];
        if (this.pagination.page > 1) {
          this.pagination.pages.push(1);
          if (this.pagination.totalPages > 5) {
            if (this.pagination.page > this.pagination.totalPages - 3) {
              this.pagination.pages.push(2);
            }
            if (this.pagination.page > this.pagination.totalPages - 2) {
              this.pagination.pages.push(3);
            }
          }
          if (this.pagination.page > 2) {
            this.pagination.pages.push('...');
          }
        }
        for (let i = iStart; i < iStart + 3; i += 1) {
          if (i >= this.pagination.totalPages) continue; // eslint-disable-line
          this.pagination.pages.push(i + 1);
        }
        if (this.pagination.totalPages > 3) {
          if (this.pagination.page < this.pagination.totalPages - 4) {
            this.pagination.pages.push('...');
          }
          if (this.pagination.page < this.pagination.totalPages - 2) {
            for (let i = this.pagination.totalPages - 2; i < this.pagination.totalPages; i += 1) {
              if (i - 1 <= this.pagination.page) continue; // eslint-disable-line
              this.pagination.pages.push(i + 1);
            }
          }
        }
      }
    },
    getDirectories() {
      const uri = `article/directory?parentId=${this.page.directory.id}&content=y`;
      this.$http.get(this.$config.uri(uri)).then((r) => {
        this.loading = false;
        this.directories = r.data.status === 200 ? r.data.data : [];
      });
    },
  },
  created() { document.addEventListener('scroll', this.docScrolled); },
  destroyed() { document.removeEventListener('scroll', this.docScrolled); },
  mounted() {
    this.langCode = this.$route.params.lang;
    this.lang = this.langCode === 'id-id' ? 'id' : 'en';
    this.q = this.$route.query.q || '';

    /**
     * Set item per page (default to 8)
     *
     */
    this.pagination.limit = (this.page.directory && this.page.directory.itemPerPage)
      ? this.page.directory.itemPerPage : 8;

    if (this.search) this.viewType = 'list';
    else this.viewType = localStorage.getItem('icel_content_view_type') || 'grid';

    if (this.$route.query.page) {
      this.pagination.page = parseInt(this.$route.query.page, 10) - 1;
      if (!this.pagination.page) this.pagination.page = 0;
    }

    if (this.displayAs === 'tab') {
      this.$http.get(this.$config.uri('article/parents')).then((r) => {
        this.loadingCategory = false;
        this.newsCategory = (r.data.status === 200) ? r.data.data : [];
        const tabActive = this.$route.query.tab;
        if (tabActive) {
          let i = 0;
          // eslint-disable-next-line
          for (const item of this.newsCategory) {
            if (item.code === tabActive) {
              this.categorySelected = i;
              break;
            }
            i += 1;
          }
        }
        this.getData();
      });
    } else {
      this.getData();
      if (this.page.directory) this.getDirectories();
    }
  },
};
</script>

<style scoped lang="scss">
.pageContents{
  min-height: calc(100vh - 200px);
  box-sizing: border-box;
  padding-bottom: 30px;
}
.loadingFull.loadingNews{
  height: 540px;
}

.loadingCategory{
  height: 40px;
  background-color: #eee;
  margin-top: 10px;
  border-radius: 50px;
}
.tabDdCnt{
  position: relative;
  &.tabFixed{
    position: fixed;
    left: 0; right: 0; top: 60px;
    background-color: #fff;
    z-index: 9;
    @media (max-width: 680px) {
      display: none;
    }
  }
  .cnt{
    @media (max-width: 680px) {
      display: flex;
    }
  }
  .thumbSelector{
    border: #eee 1px solid;
    box-shadow: 2px 2px 2px rgba(0, 0, 0, .1);
    margin-top: 16px;
    margin-left: auto;
    display: none;
    @media (max-width: 680px) {
      display: flex;
    }
    .thumbItem{
      width: 42px; height: 42px;
      display: flex;
      align-items: center;
      justify-content: center;
      filter: grayscale(1);
      opacity: .65;
      &.active{
        opacity: 1;
        filter: none;
      }
      img{
        width: 20px;
      }
      &.grid{
        img{
          width: 18px;
        }
      }
    }
  }
  .tabDd{
    display: none;
    padding: 10px 20px;
    height: 44px;
    box-sizing: border-box;
    border-radius: 3px;
    margin-top: 16px;
    border: #eee 1px solid;
    box-shadow: 2px 2px 2px rgba(0, 0, 0, .1);
    position: relative;
    cursor: pointer;
    transition: all .3s ease;
    width: calc(100% - 100px);
    &:hover{
      background-color: #f5f5fe;
    }
    &:before{
      content: "";
      position: absolute;
      right: 10px; top: 0; bottom: 0;
      width: 20px;
      background-image: url(../assets/arrow-down-dd.png);
      background-size: 14px auto;
      background-position: center;
      background-repeat: no-repeat;
      opacity: .65;
    }
    @media (max-width: 680px) {
      display: block;
    }
  }
  .tabCnt{
    border-bottom: #eee 1px solid;
    margin-top: 10px;
    .cnt{
      display: flex;
      @media (max-width: 680px) {
        display: block;
      }
    }
    @media (max-width: 680px) {
      position: absolute;
      left: 20px; right: 120px; top: 100%;
      display: block;
      border: none;
      background-color: #fff;
      z-index: 9;
      border-radius: 5px;
      padding: 12px 0;
      margin: 0;
      box-shadow: 2px 2px 8px rgba(0, 0, 0, .2);
      display: none;
    }
    .tabItem{
      padding: 10px 40px;
      // padding-right: 80px;
      font-weight: 600;
      color: #777;
      font-size: 16px;
      margin-bottom: -1px;
      position: relative;
      cursor: pointer;
      transition: all .3s ease;
      @media (max-width: 680px) {
        padding: 10px 0px;
      }
      &:before{
        transition: all .3s ease;
        content: "";
        position: absolute;
        // right: 20px;
        left: 0; right: 0; bottom: -1px; height: 3px;
        border-radius: 10px 10px 0 0;
        @media (max-width: 680px) {
          display: none;
        }
      }
      &:hover{
        color: #444;
        &:before{
          background-color: #ccc;
        }
      }
      &.active{
        color: #035fae;
        &:before{
          background-color: #035fae;
        }
      }
    }
  }
  &.open{
    .tabCnt{
      @media (max-width: 680px) {
        display: block;
      }
    }
  }
}

.viewType{
  display: flex;
  .viewTypeItem{
    width: 36px; height: 36px;
    border-radius: 5px;
    border: transparent 1px solid;
    margin-right: 4px;
    background-size: 18px auto;
    background-position: center;
    background-repeat: no-repeat;
    opacity: .4;
    cursor: pointer;
    transition: all .3s ease;
    &:hover{
      opacity: .65;
    }
    &.list{
      background-image: url(../assets/view-list.png);
    }
    &.grid{
      background-image: url(../assets/view-grid.png);
    }
    &.active{
      background-color: #fff;
      border-color: #e5e5e5;
      box-shadow: 2px 2px 4px rgba(0, 0, 0, .04);
      opacity: 1;
      &.list{
        background-image: url(../assets/view-list-active.png);
      }
      &.grid{
        background-image: url(../assets/view-grid-active.png);
      }
    }
  }
}

.noNews{
  min-height: 400px;
  padding: 40px 0;
  color: #767676;
  font-style: italic;
  &.noNewsSearch{
    padding: 4px 0 20px;
    max-width: 860px;
    margin: 0 auto;
  }
}
.itemCnt{
  display: flex;
  flex-wrap: wrap;
  margin: 0 -15px;
  padding: 40px 0 0;
  @media (max-width: 960px) {
    margin: 0 -10px;
  }
  @media (max-width: 680px) {
    margin: 0;
    display: block;
  }
  .item{
    width: 25%;
    padding: 0 15px 60px;
    box-sizing: border-box;
    @media (max-width: 960px) {
      width: 33.3333333%;
      padding: 0 10px 60px;
    }
    @media (max-width: 680px) {
      width: auto;
      padding: 0 0 60px;
    }
    .itemIn{
      box-shadow: 0 0.125rem 0.25rem rgba(0,0,0,.075) !important;
      background-color: #fff;
      border: 1px solid rgba(0,0,0,.125);
      border-radius: .25rem;
      overflow: hidden;
      transition: all .3s ease;
      position: relative;
      &:hover{
        transform: scale(1.04);
      }
      .itemImg{
        height: 240px;
        background-color: #ccc;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        display: flex;
        align-items: center;
        justify-content: center;
        &.full{
          background-size: contain;
        }
        &.eventDate{
          background-color: rgb(0, 133, 82);
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          .edDate{
            font-size: 82px;
            font-weight: 600;
            line-height: 1;
          }
          .edMonth{
            font-size: 24px;
            margin: -4px 0 0;
          }
        }
        @media (max-width: 1460px) {
          height: 220px;
        }
        @media (max-width: 1260px) {
          height: 18vw;
        }
        @media (max-width: 960px) {
          height: 22vw;
        }
        @media (max-width: 680px) {
          height: 62vw;
        }
        &.noImg{
          background-color: #e5e5e5;
          background-image: url(../assets/icel-logo-grey.png);
          background-size: 64px auto;
          background-repeat: no-repeat;
          opacity: .64;
          &.audio{
            background-image: url(../assets/musical-note-blue.svg);
            background-color: #e3eaff;
            opacity: 1;
          }
        }
        .protectedContent{
          color: #fff;
          text-align: center;
          position: relative;
          z-index: 3;
          img{
            width: 34px;
            margin: 0 0 3px;
          }
          h4{
            margin: 0;
            font-size: 13px;
            font-weight: 400;
            color: inherit;
          }
        }
      }
      .itemInfo{
        padding: 20px;
        .itemInfoIn{
          min-height: 160px;
          .protectedContent{
            display: flex;
            align-items: center;
            border: #ccc 1px solid;
            width: 160px;
            border-radius: 5px;
            padding: 6px 8px;
            padding-right: 0;
            box-sizing: border-box;
            margin: 4px 0 10px;
            img{
              width: 26px;
              margin-right: 8px;
              opacity: .64;
            }
            h4{
              margin: 0;
              color: #767676;
              font-weight: 400;
              font-size: 14px;
            }
          }
        }
      }
      .tags{
        display: flex;
        flex-wrap: wrap;
        font-weight: 600;
        padding-bottom: 6px;
        .tagItem{
          margin-right: 10px;
          margin-bottom: 2px;
          color: #035fae;
          font-size: 14px;
        }
      }
      .metadataCnt{
        display: flex;
        flex-wrap: wrap;
        padding: 2px 0 0;
        .metadata{
          display: block;
          font-size: 14px;
          color: #767676;
          margin-right: 16px;
          margin-bottom: 8px;
          padding-left: 24px;
          position: relative;
          max-width: 240px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          &:hover{
            color: #008552;
          }
          &:before{
            content: "";
            position: absolute;
            left: 0; top: -1px; bottom: 1px;
            width: 18px;
            background-size: 18px auto;
            background-position: left center;
            background-repeat: no-repeat;
          }
          &.views{
            &:before{
              background-image: url(../assets/eye.png);
              background-size: 17px auto;
            }
          }
          &.publishDate{
            &:before{
              background-image: url(../assets/calendar-blank.png);
              background-size: 15px auto;
            }
          }
          &.author{
            &:before{
              background-image: url(../assets/user-o.png);
            }
          }
          &.directory{
            padding-left: 28px;
            &:before{
              background-image: url(../assets/folder-thin.png);
              background-size: 15px auto;
            }
          }
          &.location{
            &:before{
              background-image: url(../assets/map-marker-o.png);
            }
          }
          &.organizer{
            &:before{
              background-image: url(../assets/user-2-o.png);
            }
          }
          &.speaker{
            padding-left: 30px;
            &:before{
              background-image: url(../assets/speaker-o.png);
              background-size: 22px;
              width: 22px;
              background-position: center;
              opacity: .64;
            }
          }
        }
      }
      h4{
        margin: 0 0 6px;
        font-size: 18px;
        color: #444;
        line-height: 1.3;
        overflow: hidden;
        transition: all .3s ease;
        display: -webkit-box;
        -webkit-line-clamp: 3;
                line-clamp: 3;
        -webkit-box-orient: vertical;
      }
      p{
        margin: 0 0 6px;
        color: #767676;
        font-size: 15px;
        line-height: 1.4;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        line-clamp: 4;
        -webkit-box-orient: vertical;
      }
      .btn{
        font-size: 15px;
        padding: 0;
        box-shadow: none;
        position: relative;
        font-weight: 500;
        display: inline-block;
      }
    }
    &.protected{
      .itemImg{
        background-size: cover !important;
        position: relative;
        overflow: hidden;
        &:before{
          content: "";
          position: absolute;
          left: 0; right: 0; top: 0; bottom: 0;
          background-color: #000;
          opacity: .24;
        }
        &.noImg{
          background-image: none !important;
          background-color: #ccc !important;
        }
      }
    }
    &.profile{
      .itemIn{
        .itemInfo{
          padding: 20px;
          .itemInfoIn{
            min-height: 120px;
          }
        }
        .btn{
          background-color: #e9e9e9;
          color: #444;
          border-radius: 3px;
          padding: 8px 16px;
          padding-left: 38px;
          font-weight: 400;
          transition: all .46s ease;
          &:before{
            content: "";
            position: absolute;
            right: auto;
            left: 12px; top: 0; bottom: 2px;
            background-position: center;
            background-repeat: no-repeat;
            width: 18px;
            height: auto;
            background-image: url(../assets/user-black.png);
            background-size: 16px auto;
            transition: all .46s ease;
            opacity: .65;
          }
          &:after{
            content: "";
            position: absolute;
            left: 12px; top: 0; bottom: 2px;
            width: 18px;
            background-position: center;
            height: auto;
            background-image: url(../assets/user-white.png);
            background-repeat: no-repeat;
            background-size: 16px auto;
            transition: all .46s ease;
            opacity: 0;
          }
          &:hover{
            background-color: #008552;
            color: #fff;
            &:before{
              opacity: 0;
            }
            &:after{
              opacity: 1;
            }
          }
          &.scholar{
            width: 38px; height: 38px;
            border-radius: 50%;
            padding: 0;
            position: absolute;
            right: 20px; bottom: 19px;
            &:before{
              left: 0; width: 100%; bottom: 0;
              background-size: 20px auto;
              background-image: url(../assets/graduation-black.png);
            }
            &:after{
              left: 0; width: 100%; bottom: 0;
              background-size: 20px auto;
              background-image: url(../assets/graduation-white.png);
            }
          }
        }
      }
    }
  }
  &.list{
    margin: 0 auto;
    display: block;
    max-width: 860px;
    .item{
      padding: 0 0 20px;
      width: auto;
      .itemIn{
        padding-left: 170px;
        position: relative;
        &:hover{
          transform: scale(1.02);
        }
      }
      .itemImg{
        position: absolute;
        width: 140px;
        left: 20px; top: 20px; bottom: 20px;
        height: auto;
        border-radius: 5px;
        &.eventDate{
          .edDate{
            font-size: 64px;
            font-weight: 600;
            line-height: 1;
          }
          .edMonth{
            font-size: 18px;
            margin: -2px 0 0;
          }
        }
      }
    }
  }
  &.grid{
    &.pdf{
      margin: 0 -8px;
    }
    .item{
      .itemIn{
        .metadataCnt{
          .metadata{
            margin-right: 10px;
            margin-bottom: 2px;
            font-size: 13px;
            padding-left: 16px;
            &:before{
              background-size: 13px auto;
            }
            &.publishDate:before{
              background-size: 10px auto;
            }
            &.location{
              padding-left: 14px;
              &:before{
                background-size: 11px auto;
              }
            }
            &.organizer{
              padding-left: 14px;
              &:before{
                background-size: 11px auto;
              }
            }
            &.speaker{
              &:before{
                background-size: 12px auto;
                background-position: left center;
              }
            }
          }
        }
      }
      &.pdf{
        width: 50%;
        padding: 0 8px 16px;
        @media (max-width: 960px) {
          width: 100%;
        }
        .itemIn{
          background-color: #fff;
          position: relative;
          padding-left: 188px;
          padding-top: 24px;
          box-sizing: border-box;
          box-shadow: 0 0.125rem 0.25rem rgba(0,0,0,.075) !important;
          border: 1px solid rgba(0,0,0,.125);
          border-radius: .25rem;
          min-height: 240px;
          .itemImg{
            position: absolute;
            left: 22px; top: 22px; bottom: 22px;
            border-radius: 5px;
            width: 140px;
            margin: 0;
            height: auto;
          }
          .itemInfo{
            padding: 0;
            padding-right: 20px;
          }
        }
      }
    }
  }
}
.itemList{
  .itemListItem{
    .directoryName{
      margin: 30px 0 16px;
      font-size: 24px;
    }
    .itemCnt{
      padding: 0;
    }
  }
}

.pagination{
  display: flex;
  padding: 0 0 60px;
  justify-content: flex-end;
  margin: 0;
  &.center{
    justify-content: center;
  }
  .pItem{
    margin: 0 2px;
    a, span{
      display: block;
      padding: 8px 16px 7px;
      font-size: 14px;
      font-weight: 500;
      border-radius: 5px;
      border: #e5e5e5 1px solid;
      background-color: #fff;
      transition: all .3s ease;
      color: #444;
      cursor: pointer;
      &.active{
        background-color: #333;
        color: #fff;
        cursor: default;
      }
    }
    &:hover{
      span, a{
        background-color: #008552;
        color: #fff;
      }
    }
  }
}
</style>
